// extracted by mini-css-extract-plugin
export default {"poll":"L2V-B","header":"UeZ9q","title":"r-Jx4","options":"JTWFa","option":"udoSg","optionVotes":"GGlXG","progressBar":"_6dw58","voteButton":"m3dNN"};